export default [
  {
    title: 'All pins',
    to: 'pins',
    permissions: [{
      subject: 'pin',
      actions: ['list-all'],
    }],
  },
  {
    title: 'Running Pins',
    to: 'running-pins',
    permissions: [{
      subject: 'pin',
      actions: ['list-all'],
    }],
  },
];
